import {
  DialogType,
  useConnectivityDialogDescription,
} from '#features/app/state/connectivity-dialog';
import { withSubscribe } from '#lib/withSubscribe';
import authService from '#services/auth';
import { DisconnectedDialogComponent } from './DisconnectedDialog';
import { ForcedSignOutDialog } from './ForcedSignOutDialog';
import { ReconnectingDialogComponent } from './ReconnectingDialog';

/**
 * Single component to handle all connectivity dialogs, to avoid dialogs to
 * compete against eachother.
 */
export const ConnectivityDialog = withSubscribe(() => {
  const dialog = useConnectivityDialogDescription();

  return (
    <>
      <ReconnectingDialogComponent open={dialog === DialogType.reconnecting} />
      <DisconnectedDialogComponent open={dialog === DialogType.disconnected} />
      <ForcedSignOutDialog
        open={dialog === DialogType.forceLogout}
        onClose={() => {
          authService.logout(false);
        }}
      />
    </>
  );
});
